import React from 'react';
import { DropDown } from './common';
import { GiaiQuyetDonThu } from 'api';

class DropDownNguoiKy extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      data: []
    }
  }

  componentDidMount() {
    if (this.props.isCuocThanhTra) {
      this.getNguoiBanHanhKTTT();
    } else {
      this.getData();
    }
  }
  getData() {
    GiaiQuyetDonThu.actions.getListNguoiBanHanh.request().then(res => {
      if (this.refs.chonNguoiKy) {
        if (res.data && res.data._embedded) {
          this.setState({data: res.data._embedded.congChucs});
        } else {
          this.setState({data: []});
        }
      }
    });
  }
  getNguoiBanHanhKTTT() {
    GiaiQuyetDonThu.actions.getListNguoiBanHanhKTTT.request().then(res => {
      if (this.refs.chonNguoiKy) {
        if (res.data && res.data._embedded) {
          this.setState({data: res.data._embedded.congChucs});
        } else {
          this.setState({data: []});
        }
      }
    });
  }

  onChange(e) {
    this.props.onChange(e);
  }

  render() {
    return (
      <DropDown
        label="Người ký" options={ this.state.data }
        keyName='congChucId' valueName='hoVaTen'
        onChange={ this.onChange.bind(this) }
        placeholder={ this.props.placeholder }
        selectedValue={this.props.selected}
        ref="chonNguoiKy"
        name="dropdownNguoiKy"/>
    )
  }
}

DropDownNguoiKy.defaultProps = {
  selected: '',
  onChange: function() {
    console.log('Need to assign onChange method');
  },
  placeholder: {
    key: '',
    text: 'Chọn...'
  },
  isCuocThanhTra: false
}

export default DropDownNguoiKy;



// WEBPACK FOOTER //
// ./src/components/tt-forms/DropDownNguoiKy.jsx